import { Box, Skeleton, Stack, useTheme } from "@mui/material";
import { nawyTheme } from "@/styles/nawy-theme/nawy-theme";

const RatingThreadSkeleton = () => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        backgroundColor: nawyTheme.nawy.colors.primitives.white[100],
        borderRadius: nawyTheme.nawy.radius.lg,
        padding: `${nawyTheme.nawy.spacing.md} ${nawyTheme.nawy.spacing.md}`,
        display: "flex",
        flexDirection: "column",
        gap: nawyTheme.nawy.spacing.xxs,
      }}
    >
      {/* Header: Agent and Status */}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 2,
          flexWrap: "wrap",
          justifyContent: "space-between",
        }}
      >
        <Stack
          direction="row"
          spacing={theme.nawy.spacing.xs}
          alignItems="center"
        >
          <Skeleton variant="circular" width={32} height={32} />
          <Box>
            <Skeleton variant="text" width={120} height={20} />
            <Skeleton variant="text" width={80} height={16} sx={{ mt: 0.5 }} />
          </Box>
        </Stack>
        <Skeleton
          variant="rectangular"
          width={80}
          height={24}
          sx={{ borderRadius: nawyTheme.nawy.radius.sm }}
        />
      </Box>

      {/* Star Rating */}
      <Box>
        <Stack direction="row" spacing={0.5}>
          {Array.from({ length: 5 }).map((_, index) => (
            <Skeleton
              key={index}
              variant="rectangular"
              width={20}
              height={20}
            />
          ))}
        </Stack>
      </Box>

      {/* Comment Text */}
      <Skeleton variant="text" width="100%" height={24} />
      <Skeleton variant="text" width="80%" height={24} />

      {/* Touchpoint */}
      <Skeleton variant="text" width={150} height={18} />

      {/* Created Date */}
      <Skeleton variant="text" width={120} height={14} />

      {/* Comments Section */}
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: nawyTheme.nawy.spacing.xs,
          marginTop: nawyTheme.nawy.spacing.xs,
        }}
      >
        {Array.from({ length: 2 }).map((_, index) => (
          <Box
            key={index}
            sx={{
              display: "flex",
              flexDirection: "row",
              position: "relative",
            }}
          >
            {/* Vertical Line */}
            <Box
              sx={{
                left: 0,
                top: 0,
                bottom: 0,
                width: 4,
                borderRadius: nawyTheme.nawy.radius.full,
                backgroundColor: nawyTheme.nawy.colors.semantic.layer.secondary,
              }}
            />

            {/* Comment Content */}
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                gap: nawyTheme.nawy.spacing.xs,
                flex: 1,
                marginLeft: nawyTheme.nawy.spacing.sm,
                paddingTop: nawyTheme.nawy.spacing.xs,
                paddingBottom: nawyTheme.nawy.spacing.xs,
              }}
            >
              {/* Comment Text */}
              <Skeleton variant="text" width="100%" height={24} />
              <Skeleton variant="text" width="70%" height={24} />

              {/* Timestamp */}
              <Skeleton variant="text" width={100} height={16} />

              {/* User Info */}
              <Stack
                direction="row"
                spacing={theme.nawy.spacing.xs}
                alignItems="center"
                sx={{ mt: 0.5 }}
              >
                <Skeleton variant="circular" width={24} height={24} />
                <Box>
                  <Skeleton variant="text" width={80} height={16} />
                  <Skeleton
                    variant="text"
                    width={100}
                    height={14}
                    sx={{ mt: 0.5 }}
                  />
                </Box>
              </Stack>
            </Box>
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export default RatingThreadSkeleton;
